import { render, staticRenderFns } from "./FuneralAssistance.vue?vue&type=template&id=ffb1c138"
import script from "./FuneralAssistance.vue?vue&type=script&lang=js"
export * from "./FuneralAssistance.vue?vue&type=script&lang=js"
import style0 from "./FuneralAssistance.vue?vue&type=style&index=0&id=ffb1c138&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports